import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { identifyUser, resetUser } from '@/lib/analytics/posthog';

// Keeps PostHog's distinct_id aligned with the signed-in Supabase user.
// Renders nothing; mount it once inside AuthProvider.
export function AnalyticsIdentity() {
  const { user } = useAuth();

  useEffect(() => {
    if (user?.id) {
      identifyUser(user.id, user.email ? { email: user.email } : undefined);
    } else {
      resetUser();
    }
  }, [user?.id]);

  return null;
}
